import List from "./list";
import { excuseApi } from "../commons/http";
import BankTransaction from "../models/bankTransaction";

class BankTransactions extends List {

  constructor() {
    super();
    this.bankTransactions = [];
    this.total = 0;
    this.page = 1;
    this.per_page = 10;
    this.loading = false;
    this.error = null;
  }

  setLoading(loading) {
    this.loading = loading;
  }

  setError(error) {
    this.error = error;
  }

  async getBankTransactions(page, per_page, params = {}) {
    try {
      const res = await excuseApi({
        path: '/bank-transactions',
        method: 'GET',
        params: {
          page,
          per_page,
          ...params
        }
      });

      if (res.status === 200) {
        // Check if the response has the expected structure
        if (!res.data || !res.data.data) {
          console.error("Unexpected API response structure:", res.data);
          return { 
            data: [], 
            total: 0,
            page: page,
            per_page: per_page
          };
        }

        return { 
          data: res.data.data || [], 
          total: res.data.total || 0,
          page: res.data.page || page,
          per_page: res.data.per_page || per_page
        };
      }

      console.error("API returned non-200 status:", res.status);
      return { 
        data: [], 
        total: 0,
        page: page,
        per_page: per_page
      };
    } catch (error) {
      console.error("Error in getBankTransactions:", error);
      console.error("Error response:", error.response);

      // Return empty data instead of throwing
      return { 
        data: [], 
        total: 0,
        page: page,
        per_page: per_page,
        error: error.message
      };
    }
  }


  async fetch(page, per_page, params = {}) {
    this.setLoading(true);
    this.setError(null);

    try {
      const response = await this.getBankTransactions(page, per_page, params);

      if (response && response.data) {
        // Replace the current page's rows; without the clear() every fetch
        // appends and the table grows by one page per click.
        this.clear();
        this.mapData(response.data);
        this.total = response.total || 0;
        this.page = response.page || page;
        this.per_page = response.per_page || per_page;
      } else {
        console.error("No data in response:", response);
        this.setError("Không có dữ liệu từ máy chủ");
        this.items = [];
        this.total = 0;
      }
    } catch (error) {
      console.error("Error fetching bank transactions:", error);
      this.setError("Lỗi khi tải dữ liệu: " + error.message);
      this.items = [];
      this.total = 0;
    } finally {
      this.setLoading(false);
    }
  }

  mapData(data = []) {
    for (const item of data) {
      const bankTransaction = new BankTransaction();
      bankTransaction.mapData(item);
      this.add(bankTransaction);
    }
  }
}

export default BankTransactions;
